import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useAuthHeaders } from 'auth/hooks';
import { quoteService } from 'chatbot/services';
import { ICreateCustomerQuotePartsPayload } from 'chatbot/types';
import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';

export const useQuoteActions = ({
  notificationPosition = NotificationPosition.TOP,
}: {
  notificationPosition?: NotificationPosition;
} = {}) => {
  return {
    ...useCreateCustomerQuoteParts(notificationPosition),
  };
};

const useCreateCustomerQuoteParts = (notificationPosition: NotificationPosition) => {
  const headers = useAuthHeaders();
  const { t } = useTranslation();

  const { errors } = useHandleErrors({
    success: { message: t('messageDataImportSuccess') },
    error: { title: t('errorTitleDataImporting') },
    position: notificationPosition,
  });

  const service = useCallback(
    (payload: ICreateCustomerQuotePartsPayload) =>
      quoteService.createCustomerQuoteParts(payload, { requestOptions: headers }),
    [headers]
  );

  const { mutateAsync } = useMutation<void, Error, ICreateCustomerQuotePartsPayload>(service, {
    ...errors,
  });

  return { createCustomerQuoteParts: mutateAsync };
};
